import { render, staticRenderFns } from "./CollectionDetail.vue?vue&type=template&id=73de13e2&"
import script from "./CollectionDetail.js?vue&type=script&lang=js&"
export * from "./CollectionDetail.js?vue&type=script&lang=js&"
import style0 from "./CollectionDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports